/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  SiteRedirect,
  SiteRedirectDestination,
  SiteRedirectInputDestination,
  SiteRedirectOrderBy,
  SiteRedirectSourcePath,
} from "./data-contracts";

/**
 * @description Creates a new redirect rule mapping a source path to a destination URL or content reference. Creating a live redirect also resolves open broken-link findings for the same source path. Use the bulk upsert endpoint instead when creating many redirects at once.
 * @tags site-redirects
 * @name CreateSiteRedirect
 * @summary Create a URL redirect rule for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/redirects
 * @secure
 */

// @ts-ignore
export const createSiteRedirect: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The broken-link finding that prompted this redirect. Must belong to this site. Used to attribute redirect creation, including drafts, to the finding. */
    siteFindingId?: string;
    /** The source path to redirect from. */
    source: SiteRedirectSourcePath;
    /**
     * Capture and append the wildcard-matched suffix to the destination URL.
     * @default false
     */
    captureWildcard?: boolean;
    /**
     * Whether the redirect is draft and not live.
     * @default false
     */
    draft?: boolean;
    /**
     * Whether the redirect is permanent for public live traffic.
     * @default false
     */
    permanent?: boolean;
    destination: SiteRedirectInputDestination;
  };
  RequestHeaders: {};
  ResponseBody: SiteRedirect;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects",
  method: "post",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Processes up to 500 redirect operations in a single request. Each redirect in the array is processed independently and the response includes per-item status. Prefer this over individual create/update calls when managing large sets of redirects.
 * @tags site-redirects
 * @name BulkUpsertSiteRedirects
 * @summary Create, update, delete, or publish site redirect rules in bulk
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/redirects
 * @secure
 */

// @ts-ignore
export const bulkUpsertSiteRedirects: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * @maxItems 500
     * @minItems 1
     */
    redirects: (
      | {
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Publish a draft redirect to live and remove the draft redirect. */
          intent: "publish";
        }
      | {
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /**
           * Redirect operation intent.
           * - live: upsert/delete a live redirect (draft=false)
           * - draft: upsert/delete a draft redirect (draft=true)
           * @default "live"
           */
          intent?: "live" | "draft";
          /**
           * Capture and append the wildcard-matched suffix to the destination URL.
           * @default false
           */
          captureWildcard?: boolean;
          /** Whether the redirect is permanent for public live traffic. */
          permanent?: boolean;
          /** If set to null, the redirect matching the source+intent target will be deleted. */
          destination: SiteRedirectInputDestination | null;
        }
    )[];
  };
  RequestHeaders: {};
  ResponseBody: {
    results: (
      | {
          /** The redirect was created. */
          status: "created";
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Whether the redirect is draft and not live. */
          draft: boolean;
          /** The ID of the created redirect. */
          id: string;
        }
      | {
          /** The redirect was updated. */
          status: "updated";
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Whether the redirect is draft and not live. */
          draft: boolean;
          /** The ID of the updated redirect. */
          id: string;
        }
      | {
          /** The redirect was deleted. */
          status: "deleted";
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Whether the deleted redirect was draft. */
          draft: boolean;
        }
      | {
          /** The draft redirect was published to live and removed from draft. */
          status: "published";
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Always false for published redirects. */
          draft: boolean;
          /** The ID of the resulting live redirect. */
          id: string;
        }
      | {
          /** There was an error processing the redirect. */
          status: "error";
          /** The source path to redirect from. */
          source: SiteRedirectSourcePath;
          /** Whether the redirect is draft and not live. */
          draft: boolean;
          /** The error message. */
          error: string;
        }
    )[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects",
  method: "put",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of redirect rules for the site. Supports filtering by draft status and searching by path. Use this to audit redirects, find a specific rule before updating it, or check whether draft redirects are pending publication.
 * @tags site-redirects
 * @name ListSiteRedirects
 * @summary List all URL redirect rules configured for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/redirects
 * @secure
 */

// @ts-ignore
export const listSiteRedirects: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Search for a redirect by path */
    search?: string;
    /**
     * Filter redirects by draft mode.
     * @default false
     */
    draft?: boolean;
    /** Sort redirects by the given field. */
    orderBy?: SiteRedirectOrderBy;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteRedirect[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects",
  method: "get",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates an existing redirect rule for a site. Only provided fields are updated.
 * @tags site-redirects
 * @name UpdateSiteRedirectById
 * @summary Update a URL redirect rule for a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
 * @secure
 */

// @ts-ignore
export const updateSiteRedirectById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site redirect */
    siteRedirectId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The source path to redirect from. */
    source?: SiteRedirectSourcePath;
    /** Capture and append the wildcard-matched suffix to the destination URL. */
    captureWildcard?: boolean;
    /** When true, it can be used to promote a draft redirect to live. */
    draft?: boolean;
    /** Whether the redirect is permanent for public live traffic. */
    permanent?: boolean;
    destination?: SiteRedirectDestination;
  };
  RequestHeaders: {};
  ResponseBody: SiteRedirect;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
  method: "patch",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-redirects
 * @name DeleteSiteRedirectById
 * @summary Delete a site redirect
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
 * @secure
 */

// @ts-ignore
export const deleteSiteRedirectById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site redirect */
    siteRedirectId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
  method: "delete",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Looks up a redirect rule by its source URL path and returns both the redirect configuration and the resolved destination URL. Use this to check whether a specific path has a redirect configured, or to resolve where a path currently points before updating or removing the redirect.
 * @tags site-redirects
 * @name GetSiteRedirectBySource
 * @summary Resolve a site redirect rule by its source path
 * @request GET:/orgs/{organizationId}/sites/{siteId}/redirect
 * @secure
 */

// @ts-ignore
export const getSiteRedirectBySource: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** The source path of the redirect. */
    source: SiteRedirectSourcePath;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    redirect: SiteRedirect;
    /** URL of the destination of the redirect. */
    target: string;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirect",
  method: "get",
  streaming: false,
  tags: ["site-redirects"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
